export const TAB_KEYS = {
  CONTACT: 'contact',
  ORGANIZATION: 'organization',
};

export const ORGANIZATION_TYPES = {
  NEW: 'new',
  CRM_COMPANY: 'crmCompany',
  REGISTERED_VENDOR: 'registeredVendor',
  GOVERNMENT_AGENCY: 'governmentAgency',
};

export const AGENCY_OFFICE_OPTIONS = [
  'Contracting Office',
  'Program Management Office',
  'Small Business Office',
  'Office of the Secretary',
  'Office of Inspector General',
  'Other',
];

export const VENDORS_SET_ASIDES = [
  {
    code: '27',
    name: 'Self Certified Small Disadvantaged Business',
  },
  {
    code: '23',
    name: 'Minority Owned Business',
  },
  {
    code: '8W',
    name: 'Women-Owned Small Business (WOSB) Program Set-Aside',
  },
  {
    code: 'A2',
    name: 'Woman Owned Business',
  },
  {
    code: 'A5',
    name: 'Veteran-Owned Small Business Set-Aside',
  },
  {
    code: 'OY',
    name: 'Black American Owned',
  },
  {
    code: 'QF',
    name: 'Service-Disabled Veteran-Owned Small Business Set-Aside (SDVOSB)',
  },
  {
    code: 'PI',
    name: 'Hispanic American Owned',
  },
  {
    code: '8E',
    name: 'Economically Disadvantaged Women Owned Small Business',
  },
  {
    code: 'NB',
    name: 'Native American Owned',
  },
  {
    code: 'QZ',
    name: 'Subcontinent Asian (Asian-Indian) American Owned',
  },
  {
    code: 'FR',
    name: 'Asian-Pacific American Owned',
  },
  {
    code: 'XY',
    name: 'Indian Tribe (Federally Recognized)',
  },
  {
    code: 'OW',
    name: 'American Indian Owned',
  },
  {
    code: '1B',
    name: 'Tribally Owned Firm',
  },
  {
    code: '05',
    name: 'Alaskan Native Corporation Owned Firm',
  },
  {
    code: '8U',
    name: 'Native Hawaiian Organization Owned Firm',
  },
];

export const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  title: '',
  contactType: '',
  origin: '',
  originDetail: '',
  email: '',
  primaryPhone: '',
  secondaryEmail: '',
  secondaryPhone: '',
  comments: '',
  organizationType: ORGANIZATION_TYPES.NEW,
  organizationName: '',
  ueiCode: '',
  cageCode: '',
  setAsides: [],
  companySize: '',
  companyPhone: '',
  companyEmail: '',
  naics: '',
  organizationNotes: '',
};

export const CONTACT_TYPES = {
  VENDOR: 'vendor',
  AGENT: 'agent',
};

export const TYPE_OPTIONS = [
  { value: CONTACT_TYPES.VENDOR, label: 'Vendor' },
  { value: CONTACT_TYPES.AGENT, label: 'Agent' },
];

export const ORIGIN_OPTIONS = [
  { value: 'referrals', label: 'Referrals' },
  { value: 'professional_associations', label: 'Professional Associations' },
  { value: 'conferences', label: 'Conferences' },
  { value: 'competitor', label: 'Competitor' },
  { value: 'supplier_portal', label: 'Supplier Portal' },
  { value: 'other', label: 'Other' },
];

export const ORIGIN_OTHER_VALUE = 'other';

export const COMPANY_SIZE_OPTIONS = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

export const VENDOR_ORGANIZATION_TYPE_OPTIONS = [
  {
    value: ORGANIZATION_TYPES.NEW,
    label: 'New Organization',
    disabled: false,
  },
  {
    value: ORGANIZATION_TYPES.CRM_COMPANY,
    label: 'My CRM Companies',
    disabled: false,
  },
  {
    value: ORGANIZATION_TYPES.REGISTERED_VENDOR,
    label: 'Registered Vendor',
    disabled: false,
  },
];

export const AGENT_ORGANIZATION_TYPE_OPTIONS = [
  {
    value: ORGANIZATION_TYPES.CRM_COMPANY,
    label: 'My CRM Agencies',
    disabled: false,
  },
  {
    value: ORGANIZATION_TYPES.GOVERNMENT_AGENCY,
    label: 'Federal Agencies',
    disabled: false,
  },
];

export const getOrganizationTypeOptions = (contactType) => {
  if (contactType === CONTACT_TYPES.AGENT) {
    return AGENT_ORGANIZATION_TYPE_OPTIONS;
  }

  return VENDOR_ORGANIZATION_TYPE_OPTIONS;
};

export const getDefaultOrganizationType = (contactType) => {
  if (contactType === CONTACT_TYPES.AGENT) {
    return ORGANIZATION_TYPES.GOVERNMENT_AGENCY;
  }

  return ORGANIZATION_TYPES.NEW;
};

export const isAgentContact = (contactType) => contactType === CONTACT_TYPES.AGENT;

export const PHONE_FIELDS = ['primaryPhone', 'secondaryPhone', 'companyPhone'];
